// extracted by mini-css-extract-plugin
module.exports = {"panel":"PricingOfferButton_panel__p46qD","description":"PricingOfferButton_description__O7p0e"};